import { Box } from '@material-ui/core';
import React from 'react';
import config from '@/configs/config';
import { ListItem, StyledButton } from './Form';

export default ({
  onRegisterStartClick,
}) => (
  <Box
    alignItems="center"
    borderRadius={26}
    boxShadow="0px 0px 8px #bfbfbf80"
    display="flex"
    flexDirection="column"
    fontSize={12}
    justifyContent="center"
    margin="auto"
    pb={3.25}
    pt={3.25}
    px={{ xs: 1, sm: 4.5 }}
    width={{
      xs: 270,
      sm: 372,
    }}
    style={{
      backgroundColor: 'rgb(242, 242, 242)',
    }}
  >
    <Box textAlign="center" fontSize={40}>友誼萬歲!</Box>
    <Box mt={2.25} alignSelf="stretch" px={{ xs: 0, sm: 3 }}>
      <img alt="" src="/images/Login/friends.png" width="100%" />
    </Box>
    <Box mt={2.5} px={{ xs: 1.5 }}>
      恭喜你接受了好友推薦邀請，現在讓我們一起加入
      {config.BrandNameTW}
      的行列吧！
    </Box>
    <Box width={1} display="flex" flexDirection="column" mt={2.5} alignItems="stretch">
      <ListItem>
        邀請好友加入
        {config.BrandNameTW}
      </ListItem>
      <ListItem>好友完成註冊會員並完成首購</ListItem>
      <ListItem>雙方即可獲得 50 元加菜金！</ListItem>
    </Box>
    <Box hieght={37} width={1} mt={2.25}>
      <StyledButton
        style={{ backgroundColor: 'rgb(242,189,31)' }}
        onClick={onRegisterStartClick}
      >
        會員註冊
      </StyledButton>
    </Box>
  </Box>
);
